var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hotelData.adult > 0 || _vm.hotelData.children > 0
        ? _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.hotelData.adult) +
                "成人" +
                _vm._s(_vm.hotelData.children) +
                "儿童 "
            ),
            _c("span", [_vm._v("/")]),
          ])
        : _vm._e(),
      _vm.hotelData.star != ""
        ? _c("span", [_vm._v(_vm._s(_vm.hotelData.star) + "/")])
        : _vm._e(),
      _vm.hotelData.location != ""
        ? _c("span", [_vm._v(_vm._s(_vm.hotelData.location) + "/")])
        : _vm._e(),
      _vm.hotelData.breakfast != ""
        ? _c("span", [_vm._v(_vm._s(_vm.hotelData.breakfast))])
        : _vm._e(),
      _vm._l(_vm.hotelData.hotelRoomList, function (room, index) {
        return _c(
          "p",
          { key: index, staticStyle: { "margin-top": "0.05rem" } },
          [
            room.roomNumber > 0 && room.roomNumber != ""
              ? _c("span", [_vm._v(_vm._s(room.roomNumber) + "间")])
              : _vm._e(),
            room.hotelRoomName != ""
              ? _c("span", [_vm._v(" " + _vm._s(room.hotelRoomName) + " ")])
              : _vm._e(),
            room.roomBudget > 0 && room.roomBudget != ""
              ? _c("span", [
                  _c("span", [_vm._v("锁死预算:")]),
                  _vm._v(
                    _vm._s(room.roomBudget) + _vm._s(room.currency) + "/间"
                  ),
                ])
              : _vm._e(),
          ]
        )
      }),
      _c(
        "p",
        { staticClass: "span1", staticStyle: { "margin-top": "0.05rem" } },
        [_vm._v(_vm._s(_vm.hotelData.remarks) + " ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }